import PropTypes from 'prop-types';

export default class LookBookCollageContainer extends React.Component {
    static propTypes = {
        ceremonyLook: PropTypes.bool,
        selectedInspiration: PropTypes.object,
        onClickInspirationLookHandler: PropTypes.func,
        videos: PropTypes.array,
        ceremonyLookImg: PropTypes.array,
        receptionLookImg: PropTypes.array,
        isDisplayingVideo: PropTypes.bool,
        onClickVideoPlaceholderHandler: PropTypes.func,
        isSelectionCombination: PropTypes.bool
    };
    static defaultProps = {
        ceremonyLook: false,
        selectedInspiration: {},
        videos: [],
        ceremonyLookImg: [],
        receptionLookImg: [],
        isDisplayingVideo: false,
        isSelectionCombination: false,
        onClickVideoPlaceholderHandler: () => null,
        onClickInspirationLookHandler: () => null
    };
    constructor() {
        super();
    }
    _renderImgCollage = (imgName, index) => <img src={`${imgName}`} className="img-responsive" alt="" key={index}/>;

    _playVideoHandler = () => {
        $('.close-video').removeClass('hide');
        if(!this.props.ceremonyLook && this.props.selectedInspiration.id === 4) {
            this.video.currentTime = 14;
        } else if (!this.props.ceremonyLook && this.props.selectedInspiration.id === 8) {
            this.video.currentTime = 8;
        } else if (!this.props.ceremonyLook && this.props.selectedInspiration.id === 9) {
            this.video.currentTime = 18;
        } else if (!this.props.ceremonyLook && this.props.selectedInspiration.id === 10) {
            this.video.currentTime = 17;
        } else if (!this.props.ceremonyLook && this.props.selectedInspiration.id === 12) {
            this.video.currentTime = 27;
        } else {
            this.props.ceremonyLook ? this.video.currentTime = 0 : this.video.currentTime = 16;
        }
        (this.props.isDisplayingVideo) ? this.video.pause() : this.video.play();
        this.props.onClickVideoPlaceholderHandler();
    };
    _stopVideo = (e) => {
        const el = e.target;

        el.classList.add('hide');

        this.props.onClickVideoPlaceholderHandler();
    };
    _renderCombinationCollage = () => <img src={`//cdn.sandals.com/sandals/v12/images/wedding-styler/combinations/by-${this.props.selectedInspiration.id}.jpg`} className="img-responsive" alt={`Inspired by ${this.props.selectedInspiration.id}`} />;

    render() {

        return (
            <div className="look-book-collage-wrapper txt-center">
                <h3 className="look-book-collage-ttl">
                    { this.props.selectedInspiration.name }
                    <small className="insp-comb-label">{`${(this.props.isSelectionCombination) ? 'COMBINATION' : 'INSPIRATION'}`}</small>
                </h3>
                {
                    !this.props.isSelectionCombination &&
                    <div className="btn-wrapper">
                        <div className="col-xs-6 left-btn">
                            <button id="ceremony" className={`inspiration-btn ${ (this.props.ceremonyLook) ? 'active' : '' }`} onClick={ this.props.onClickInspirationLookHandler } >
                                CEREMONY LOOK
                            </button>
                        </div>
                        <div className="col-xs-6 right-btn">
                            <button id="reception" className={`inspiration-btn ${ (this.props.ceremonyLook) ? '' : 'active' }`} onClick={ this.props.onClickInspirationLookHandler } >
                                RECEPTION LOOK
                            </button>
                        </div>
                    </div>
                }
                <div className="collage-wrapper pr container">
                {
                    !this.props.isSelectionCombination && this.props.videos.length > 0 &&
                    <div className={`video-wrapper ${(this.props.isDisplayingVideo) ? 'active-video' : ''}`}>
                        <button className="play-video pa" onClick={ this._playVideoHandler } />
                        <button className="close-video hide" onClick={ this._stopVideo } />
                        <button className="hide-video pa white hide" onClick={ this._playVideoHandler } ><i className="icon-remove"/></button>
                    {
                        this.props.selectedInspiration.id &&
                        <video preload="auto" src={ this.props.videos[1].src } loop muted volume="0" ref={ (video) => { this.video = video; } }>
                            {
                                this.props.videos.map( (video, index) => <source src={video.src} type={video.type} key={index} />)
                            }
                        </video>
                    }
                    </div>
                }
                {
                    (this.props.selectedInspiration.id && this.props.ceremonyLook && !this.props.isSelectionCombination) && this.props.ceremonyLookImg.map((imgName, index) => this._renderImgCollage(imgName, index))
                }
                {
                    (this.props.selectedInspiration.id && !this.props.ceremonyLook && !this.props.isSelectionCombination) && this.props.receptionLookImg.map((imgName, index) => this._renderImgCollage(imgName, index))
                }
                {
                    this.props.isSelectionCombination && this._renderCombinationCollage()
                }
                </div>
                <h3 className="wddng-credit-offer-copy arial">RECEIVE <big>$500 WEDDING CREDIT</big> WHEN YOU DESIGN YOUR OWN</h3>
                <a href={`${(!this.props.isSelectionCombination) ? `/en/weddings/ideas/collection-details/?inspirationId=${this.props.selectedInspiration.id}` : '/weddings/ideas/'}`} className="btn-get-started btn-default arial">{`${(this.props.isSelectionCombination) ? 'VIEW INSPIRATIONS' : 'GET STARTED'}`}<i className="icon-stylish-right-arrow ib"/></a>
            </div>
        );
    }
}